<script lang="ts">
  import {OverlayLoaderShow} from "$lib/stores";

  let show = $state(false);
  OverlayLoaderShow.subscribe(value => {
    show = value;
  });
</script>

<div class="z-50 {show ? 'fixed' : 'hidden'}">
  <div class="fixed top-0 left-0 w-full h-full bg-black bg-opacity-60 z-50 flex justify-center items-center">
    <enhanced:img src="$lib/logo.svg?enhanced" class="animate-bounce " width="140" alt="Forza.bet"/>
  </div>
</div>
